export default __webpack_public_path__ + "18786197baae6df26dc7a7112795405d.jpg";